import Api from '@/services/Api'

const resource = 'token/'

export default {
  singin(credencials) {
    return Api().post(resource, credencials)
  },
}
